module.exports = __webpack_public_path__ + "static/assets/5da5be15a10e13a8bf501a6cc11c6d98.svg";